import { defineMessages } from "react-intl";

export const messages = defineMessages({
    confirmSaveBelowMinAcreage: {
        id: "fieldInformation.confirmSaveBelowMinAcreage",
        defaultMessage:
            "One or more polygons are less than {minAcres, number} acres.  Save anyway?",
    },
    confirmSaveBelowTitle: {
        id: "fieldInformation.confirmSaveBelowTitle",
        defaultMessage: "Confirm",
    },
    errorAboveMaxAcreage: {
        id: "fieldInformation.errorAboveMaxAcreage",
        defaultMessage:
            "This field is larger in area than the system limit of {maxAcres, number} acres.  You need to reduce the size of the field below this limit.",
    },
    errorAboveMaxAcreageTitle: {
        id: "fieldInformation.errorAboveMaxAcreageTitle",
        defaultMessage: "Error",
    },
    errorInvalidBillSplitsTitle: {
        id: "fieldInformation.errorInvalidBillSplitsTitle",
        defaultMessage: "Bill Split Error",
    },
    errorInvalidBillSplits: {
        id: "fieldInformation.errorInvalidBillSplits",
        defaultMessage:
            "Each of the 3 Bill Split arrangements must equal 100 across the selected Customer(s).",
    },
    errorInvalidGeometriesTitle: {
        id: "fieldInformation.errorInvalidGeometriesTitle",
        defaultMessage: "Geometry Error",
    },
    errorInvalidGeometries: {
        id: "fieldInformation.errorInvalidGeometries",
        defaultMessage:
            "Geometries are intersecting.  Please clip any intersections before saving.",
    },
});
